<ng-container [ngSwitch]="isSelected">
  <awair-back-icon *ngSwitchCase="true"
                   class="__button--clickable"
                   [color]="'#FFFFFF'"
                   (click)="onClickBack(isFloorPlanEdited)">
  </awair-back-icon>
  <awair-floor-icon *ngSwitchDefault
                    class="__button"
                    [color]="'#FFFFFF'">
  </awair-floor-icon>
  <div class="__divider-right"></div>
</ng-container>

<span class="__name">{{name}}</span>
